import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setModelImageMode } from '@common/Listing/actions/listingActions';
import ListingContext from '@common/Listing/ListingContext';

export function useListingTop() {
    const dispatch = useDispatch();
    const { theme } = useContext(ListingContext);

    const modelImageMode = useSelector(({ listing }) => listing.modelImageMode);

    const onToggleChange = () => {
        dispatch(setModelImageMode(!modelImageMode));
    };

    return {
        theme,
        modelImageMode,
        onToggleChange
    };
}
